<template>
    <section class="property-mls" v-if="!dpp.isPrOnly">
        <template v-if="listingAgent">
            <template v-if="dpp.isNHS || dpp.isRDC || dpp.isRentals">Listed by {{listingAgent}}, </template>
            <template v-else>
                <span>Listing Agent - {{listingAgent}};</span>
            </template>
            <span v-if="dpp.agentDetails && dpp.agentDetails.agentContactInfo"> Listing Agent Contact: {{dpp.agentDetails.agentContactInfo}}; </span>
            <span v-if="dpp.officeListName"> Listing Office - {{dpp.officeListName}}, </span>
        </template>
        <template v-else-if="dpp.officeListName">
            <span v-if="dpp.agentDetails && dpp.agentDetails.agentContactInfo"> Listing Agent Contact: {{dpp.agentDetails.agentContactInfo}}; </span>
            <span> Listing Office - {{dpp.officeListName}}</span>
        </template>
        <template v-if="dpp.isSold && dpp.showBuyingOffice && buyingOffice">
            <span>Bought by {{buyingOffice}}, </span>
        </template>
        <template v-if="dpp.isNHS">
            <span>Source: </span>
            <a v-nhs:click @click="sendGA" class="link" :href="nhsExternalLink" target="_blank">NewHomeSource.com</a>
            <span data-allow-mismatch="text" v-if="getUpdatedStatus.lastUpdate"> Last updated: {{getUpdatedStatus.lastUpdate}}.</span>
        </template>
        <template v-else-if="dpp.isRDC">
            <span>Source: </span>
            <a class="link" :href="rdcExternalLink" target="_blank">Realtor.com</a>
            <span data-allow-mismatch="text" v-if="getUpdatedStatus.lastUpdate"> Last updated: {{getUpdatedStatus.lastUpdate}}.</span>
        </template>
        <template v-else-if="dpp.isRentals">
            <span>Source: </span>
            <a :href="getRentalUrl()" rel="nofollow noopener" target="_blank"><img v-if="rentalInfo.image" class="img-rental-icon" :alt="getMlsInfo.mlsName + ' logo'" loading="lazy" :src="rentalInfo.image"/>{{getMlsInfo.mlsName}}</a>
            <span data-allow-mismatch="text" v-if="getUpdatedStatus.lastUpdate">last updated {{getUpdatedStatus.lastUpdate}}. </span>
        </template>
        <template v-else-if="dpp.mlsNumber">
            <span>Source: </span>
            <span class="mls-name" v-if="getMlsInfo.mlsName || mlsLogoSrc">
                {{getMlsInfo.mlsName || ''}}<img v-if="mlsLogoSrc" alt="mls logo" loading="lazy" :src="mlsLogoSrc"/>,
            </span>

            <span>MLS#{{dpp.mlsNumber}}</span>
            <span data-allow-mismatch="text" v-if="getUpdatedStatus.lastUpdate">last updated {{getUpdatedStatus.lastUpdate}}. </span>
        </template>
        <template v-if="lastChecked">
            <span>Movoto</span>
            <a v-if="glb.isMobile && !complianceHidePhone()" :href="'tel:' + getPhoneNumber" class="link">
                <i class="icon-phone"></i>
            </a>
            <span data-allow-mismatch="text">checked {{getMlsInfo.mlsName || 'MLS'}} for data {{ lastChecked }}.</span>
        </template>
        <template v-if="isMounted && showMLSCheckTimestamp(getUpdatedStatus.mlsCheckedTimestamp)">
            <span data-allow-mismatch="text">Movoto refreshed data at {{$filters.formatDate(getUpdatedStatus.mlsCheckedTimestamp, {raw: true})}}.</span>
        </template>



        <span v-if="basicInfoDisclaimer()" v-html="basicInfoDisclaimer()"></span>
        <template v-if="brokerInfo">
            <i class="icon-logo-m-new"></i>
            <span>{{brokerInfoDetails()}}</span>
            <a v-if="brokerInfo.dppBrokerPhone && !complianceHidePhone()" :href="'tel:' + brokerInfo.dppBrokerPhone" class="link">
                <i class="icon-phone"></i>
            </a>
            <a v-if="brokerInfo.dppBrokerEmail" :href="'mailto:' + brokerInfo.dppBrokerEmail" class="link">
                <i class="icon-envelope"></i> {{brokerInfo.dppBrokerEmail}}
            </a>
        </template>
    </section>
</template>
<script src="./property-mls.js"></script>

<style lang="scss">
@use "./property-mls.scss" as *;
</style>
